/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="(chmenu, index) in menu.menus" :index="'/'+chmenu.url" :key="index">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 150,
          icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
          menuname: '首页',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 159,
              icon: 'icon-provider-manage',
              menuname: 'USDT支付的动态统计',
              hasThird: 'N',
              url: 'charts/statistics',
              menus: null
            }
          ]
        },
        {
          menuid: 3,
          icon: 'li-icon-xiangmuguanli',
          menuname: '订单管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 4,
              icon: 'li-icon-zhifuguanli',
              menuname: '订单列表',
              hasThird: 'N',
              url: 'pay/Order',
              menus: null
            },
            // {
            //   menuid: 5,
            //   icon: 'icon-order-manage',
            //   menuname: '会员收益明细',
            //   hasThird: 'N',
            //   url: 'system/userList',
            //   menus: null
            // }
          ]
        },
        {
          menuid: 4,
          icon: 'icon-cms-refri',
          menuname: '店铺管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 44,
              icon: 'icon-order-manage',
              menuname: '店铺信息',
              hasThird: 'N',
              url: 'system/userList',
              menus: null
            }
            // ,{
            //   menuid: 46,
            //   icon: 'icon-order-manage',
            //   menuname: '其他商家审核',
            //   hasThird: 'N',
            //   url: 'system/moreList',
            //   menus: null
            // },
            // {
            //   menuid: 48,
            //   icon: 'icon-order-manage',
            //   menuname: '店铺列表',
            //   hasThird: 'N',
            //   url: 'system/shop',
            //   menus: null
            // }
          ]
        },
        {
          menuid: 33,
          icon: 'li-icon-dingdanguanli',
          menuname: '商品管理',
          hasThird: null,
          url: null,
          menus: [
            // {
            //   menuid: 36,
            //   icon: 'icon-cat-skuBasic',
            //   menuname: '商品分类列表',
            //   hasThird: 'N',
            //   url: 'pay/GoodsCLass',
            //   menus: null
            // },
            {
              menuid: 37,
              icon: 'li-icon-xiangmuguanli',
              menuname: '上传商品',
              hasThird: 'N',
              url: 'pay/AddGoods',
              menus: null
            },
            {
              menuid: 34,
              icon: 'icon-provider-manage',
              menuname: '商品列表',
              hasThird: 'N',
              url: 'pay/Goods',
              menus: null
            }
            // {
            //   menuid: 35,
            //   icon: 'icon-order-manage',
            //   menuname: '订单列表',
            //   hasThird: 'N',
            //   url: 'pay/Order',
            //   menus: null
            // }
          ]
        },
        // {
        //   menuid: 71,
        //   icon: 'li-icon-xitongguanli',
        //   menuname: '权限管理',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 73,
        //       icon: 'icon-news-manage',
        //       menuname: '角色管理',
        //       hasThird: 'N',
        //       url: 'system/Role',
        //       menus: null
        //     }
        //   ]
        // },
        // {
        //   menuid: 2,
        //   icon: 'li-icon-jichuguanli',
        //   menuname: '系统设置',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 25,
        //       icon: 'icon-order-manage',
        //       menuname: '轮播列表',
        //       hasThird: 'N',
        //       url: 'adminSet/otherSet',
        //       menus: null
        //     },{
        //       menuid: 26,
        //       icon: 'icon-cs-manage',
        //       menuname: '公告列表',
        //       hasThird: 'N',
        //       url: 'adminSet/noteSet',
        //       menus: null
        //     },{
        //       menuid: 27,
        //       icon: 'li-icon-shujujiankong',
        //       menuname: '编辑公告',
        //       hasThird: 'N',
        //       url: 'adminSet/noteAddSet',
        //       menus: null
        //     }
        //   ]
        // }
      ],
      msg: 'success'
    }
          this.allmenu = res.data
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue